import {
  Box,
  Checkbox,
  useTheme,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import FormHelperText from '../FormHelperText';
import LabeledBox from '../../special/LabeledBox';
import { useEffect } from 'react';

const TypeCheckbox = ({
  field,
  dataCollection,
  errors,
  updateValidationOnChange,
  size,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  useEffect(() => {
    if (!field?.key) return;
    // Only set default value if no value exists in dataCollection
    if (dataCollection[field.key] === undefined || dataCollection[field.key] === null) {
      updateValidationOnChange([field.key], field.initialValue ?? '0');
    }
  }, [field.key, dataCollection[field.key]]);

  function handleChange() {
    const currentValue =
      typeof dataCollection[field.key] === 'boolean'
        ? dataCollection[field.key]
        : Boolean(parseInt(dataCollection[field.key]));

    updateValidationOnChange([field.key], !currentValue ? '1' : '0');
  }

  return (
    <LabeledBox
      className="flex flex-row items-center justify-start cursor-pointer w-full"
      sx={{ padding: '0px 3px', height: size !== 'small' ? '53px' : 'auto' }}
      onClick={field.disabled ? () => {} : handleChange}
      size={size}
    >
      <Checkbox
        size={size}
        color="secondary"
        disabled={field.disabled}
        checked={
          typeof dataCollection[field.key] === 'boolean'
            ? dataCollection[field.key]
            : Boolean(parseInt(dataCollection[field.key]))
        }
      />
      <Typography color={field.disabled ? 'text.disabled' : 'text.primary'}>
        {field.label}
      </Typography>
      <FormHelperText />
    </LabeledBox>
  );
};

export default TypeCheckbox;
